import { render, staticRenderFns } from "./synchronizeTime.vue?vue&type=template&id=26f5a475&scoped=true&"
import script from "./synchronizeTime.vue?vue&type=script&lang=js&"
export * from "./synchronizeTime.vue?vue&type=script&lang=js&"
import style0 from "./synchronizeTime.vue?vue&type=style&index=0&id=26f5a475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f5a475",
  null
  
)

export default component.exports